import { combineValidateRules } from 'legacy/lut/helpers/combineValidateRules'
import { checkMaxLength } from 'legacy/lut/helpers/validateRules/checkMaxLength'
import { useState } from 'react'

import { Button } from 'core-components/library/button'
import {
  Controller,
  isEmpty,
  ValidateTextarea,
  ValidationStatus,
} from 'core-components/library/validation'

import styles from './PartnerCompliancePage.module.scss'

interface IProps {
  onSave: (comment: string) => Promise<void>
  comment?: string
}

const MAX_COMMENT_LENGTH = 1000
const checkMaxCommentLength = (value: string) => checkMaxLength(value.trim(), MAX_COMMENT_LENGTH)

export const RejectPartner = ({ onSave, comment: savedComment }: IProps) => {
  const [comment, setComment] = useState(savedComment || '')
  const [isValid, setIsValid] = useState(false)

  return (
    <div>
      <Controller
        onValidationStatusChange={({ status }) =>
          status !== ValidationStatus.WIP && setIsValid(status === ValidationStatus.Valid)
        }
      >
        <div className={styles.rejectionLabelWrapper}>Please, provide the reason of rejection:</div>
        <ValidateTextarea
          placeholder={'Comment...'}
          label={'Comment'}
          value={comment}
          checkFn={combineValidateRules([isEmpty, checkMaxCommentLength])}
          onChange={setComment}
          margin={'md'}
          rows={4}
          resizable={'vertical'}
          autoFocus
        />
        <Button onClick={() => onSave(comment.trim())} disabled={!isValid}>
          Save
        </Button>
      </Controller>
    </div>
  )
}
